import React from 'react';
import { mainsPlug } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Electrical store',
  synonyms: 'shop store',
  group: 'standardMarker',
  typeUrl: 'electrical-store',
  icon: {
    baseShape: mainsPlug,
    iconColor: '#fff',
    markerColor: '#906BD9',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'general-services',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'electricalStoreMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Electrical store',
      itemTitleFunction: (item) => (item && item.title) || 'Electrical store',
    },
    creationOptions: {
      menuText: 'Electrical store',
      newTitle: 'Electrical store',
      titlePlaceholder: 'Name of electrical store',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates an electrical store location.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Electrical store',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
